module.exports = __webpack_public_path__ + "files/9fc8902c40bf60b14333e02ad8a1370d.png";